module.exports = __webpack_public_path__ + "../resources/img/ic_re_partly_cloudy_night_solid.2b4a0c4f.svg";